import {
  ContentEntity,
} from './contentEntity';
import { ContentAttachment } from './valueObjects/contentAttachment';
import { ContentImage } from './valueObjects/contentImage';
import { ContentS3Path } from './valueObjects/contentS3Path';
import { ContentText } from './valueObjects/contentText';

import type {
  ContentProps,
} from './contentEntity';
import type { ContentJson } from '@/types/domain/privateBlog/entities/contentEntity';

import { Factory } from '@/domain/factory';

/**
 * コンテンツファクトリ
 */
export class ContentFactory extends Factory<
  ContentEntity,
  ContentProps,
  ContentJson
> {
  /**
   * 比較
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePvt = (a: ContentJson, b: ContentJson) => a.id.localeCompare(b.id, 'en');

  /**
   * Entityを生成する
   * @param props プロパティ
   * @returns Entity
   */
  createPvt(props: ContentProps): ContentEntity {
    return new ContentEntity(props, null);
  }

  /**
   * JsonからEntityを生成する
   * @param props Json
   * @returns Entity
   */
  createFromJsonPvt(props: ContentJson): ContentEntity {
    return this.createPvt({
      id: props.id,
      s3Path: props.s3Path ? ContentS3Path.create(props.s3Path) : undefined,
      text: ContentText.create(props.text),
      images: props.images.map((v) => ContentImage.create(v)),
      attachments: props.attachments.map((v) => ContentAttachment.create(v)),
    });
  }
}
